import { useNavigate } from 'react-router-dom';

const Result = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #00A651 0%, #1a1a1a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', color: '#fff', padding: '20px' }}>
        <img src="/logo.png" alt="Reaktor Nature Power" style={{ width: '120px', marginBottom: '20px' }} />
        <h2>Résultat</h2>
        <button onClick={() => navigate('/')} className="btn btn-light mt-3">Retour</button>
      </div>
    </div>
  );
};

export default Result;
